import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const MicDisabled = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        id='Icon'
        d='M12 21v-2m0 0c-3.678 0-5.853-2.255-6.986-4M12 19c2.228 0 3.905-.828 5.132-1.868M9.52 3.862A4 4 0 0 1 16 7v3.343M3 3l5 5m0 0v3a4 4 0 0 0 6.284 3.284M8 8l6.284 6.284m0 0 2.848 2.848m0 0L21 21'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.25a4.73 4.73 0 0 0-2.947 1.024.75.75 0 0 0-.064 1.119l6.48 6.48a.75.75 0 0 0 1.281-.53V7A4.75 4.75 0 0 0 12 2.25m-8.47.22a.75.75 0 0 0-1.06 1.06l4.78 4.78V11a4.75 4.75 0 0 0 6.917 4.228l1.828 1.827c-1.031.697-2.341 1.195-3.995 1.195-3.32 0-5.294-2.02-6.357-3.658a.75.75 0 0 0-1.258.816c1.126 1.735 3.28 4.028 6.865 4.313V21a.75.75 0 0 0 1.5 0v-1.28a8.4 8.4 0 0 0 4.322-1.588l3.398 3.398a.75.75 0 1 0 1.06-1.06z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
